import { BottomSheet } from '../BottomSheet';
import { primaryBtn, secondaryBtn } from '../ui/classes';
import { plural } from './status';

interface Props {
  open: boolean;
  pending: number;
  busy: boolean;
  onClose: () => void;
  onFinish: (markMissing: boolean) => void;
}

/** Potwierdzenie końca zakupów, gdy zostały nieodhaczone pozycje. */
export function FinishSheet({ open, pending, busy, onClose, onFinish }: Props) {
  const verb = plural(pending, 'Została', 'Zostały', 'Zostało');
  const what = plural(pending, 'pozycja', 'pozycje', 'pozycji');
  const them = pending === 1 ? 'ją' : 'je';
  return (
    <BottomSheet open={open} onClose={onClose} title="Zakończyć zakupy?">
      <p className="mb-4 text-stone-600 dark:text-stone-400">
        {verb} {pending} {what} — oznaczyć {them} jako brak?
      </p>
      <div className="flex flex-col gap-2">
        <button type="button" disabled={busy} onClick={() => onFinish(true)} className={primaryBtn}>
          Tak, jako brak
        </button>
        <button type="button" disabled={busy} onClick={() => onFinish(false)} className={secondaryBtn}>
          Zakończ bez zmian
        </button>
        <button type="button" disabled={busy} onClick={onClose} className="min-h-12 rounded-xl font-medium text-stone-600 active:bg-stone-100 dark:text-stone-400 dark:active:bg-stone-800">
          Anuluj
        </button>
      </div>
    </BottomSheet>
  );
}
